export { default } from '@framework/tenant/config/users';
